"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import Link from "next/link";
import { useChecklist } from "@/hooks/useChecklist";

export interface ChecklistItem {
  id: string;
  task: string;
  schedule: string;
  method: string;
  link: string;
}

interface ChecklistTableProps {
  items: ChecklistItem[];
  cookieName: string;
}

export default function ChecklistTable({
  items,
  cookieName,
}: ChecklistTableProps) {
  // 쿠키 영속 + 본문↔사이드바(ChecklistMini) 양방향 동기화는 useChecklist 가 담당(JCG-2101).
  const { checkedState, toggle } = useChecklist(cookieName);

  return (
    <div className="not-prose">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[60px] text-center">완료</TableHead>
            <TableHead>할 일</TableHead>
            <TableHead>일정</TableHead>
            <TableHead>방법</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id}>
              <TableCell className="text-center">
                <Checkbox
                  aria-label={`Checkbox for ${item.task}`}
                  checked={checkedState[item.id] || false}
                  onCheckedChange={() => toggle(item.id)}
                />
              </TableCell>
              <TableCell className="font-medium">{item.task}</TableCell>
              <TableCell>{item.schedule}</TableCell>
              <TableCell>
                <Link
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  {item.method}
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
